/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Humanize_Tone_FormalInputs */



/**
* | output |
* | --- |
* | "Formal" |
*
* @param {Chat_Outlook_Humanize_Tone_FormalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_humanize_tone_formal = /** @type {((inputs?: Chat_Outlook_Humanize_Tone_FormalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Humanize_Tone_FormalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Formell")
	return /** @type {LocalizedString} */ ("Formal")
});